<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import FormSection from "@/Components/FormSection.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import SecondaryButton from "@/Components/SecondaryButton.vue";
import InputLabel from "@/Components/InputLabel.vue";
import TextInput from "@/Components/TextInput.vue";
import { useForm } from "@inertiajs/inertia-vue3";

const props = defineProps({
  carrier: Object,
  readOnly: { type: Boolean, default: false },
})

const form = useForm({
  _method: props.carrier?.carrier_id ? "PUT" : "POST",
  carrier_name: props.carrier?.carrier_name || "",
  weblink: props.carrier?.weblink || "",
})

const saveForm = () => {
  const isEdit = !!props.carrier?.carrier_id

  const routeName = isEdit
    ? route("admin.carrier.update", { carrier: props.carrier.carrier_id })
    : route("admin.carrier.store")

  form.post(routeName, {
    preserveScroll: true,
    onSuccess: () => {
      if (!isEdit) {
        window.location.href = route("admin.carrier.index")
      }
    },
  })
}
</script>

<template>
  <AppLayout :title="props.carrier?.carrier_id ? 'Edit Carrier' : 'New Carrier'">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        {{ props.readOnly ? 'View Carrier' : (props.carrier?.carrier_id ? 'Edit Carrier' : 'Create Carrier') }}
      </h2>
    </template>

    <div class="max-w-2xl mx-auto py-10 sm:px-6 lg:px-8">
      <FormSection gridClasses="grid-cols-1" :noGrid="true">
        <template #title>
          <a :href="route('admin.carrier.index')">
            <SecondaryButton>Back</SecondaryButton>
          </a>
        </template>

        <template #form>
          <div class="flex flex-col gap-4">
            <div>
              <InputLabel value="Name" />
              <TextInput
                v-model="form.carrier_name"
                class="w-full mt-1"
                :disabled="props.readOnly"
              />
              <div v-if="form.errors.carrier_name" class="text-red-600 text-sm mt-1">
                {{ form.errors.carrier_name }}
              </div>
            </div>

            <div>
              <InputLabel value="Website link" />
              <TextInput
                v-model="form.weblink"
                class="w-full mt-1"
                :disabled="props.readOnly"
              />
              <div v-if="form.errors.weblink" class="text-red-600 text-sm mt-1">
                {{ form.errors.weblink }}
              </div>
            </div>
          </div>
        </template>

        <template #actions>
          <PrimaryButton v-if="!props.readOnly" @click.prevent="saveForm">
            Save
          </PrimaryButton>
        </template>
      </FormSection>
    </div>
  </AppLayout>
</template>